import React from "react";
import { Chip, Grid, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import _ from "underscore";

/** Shared chip styling using organization LabelData `color` (text) and `backgroundColor` (accent / border). */
export function organizationLabelChipSx(label, density = "default") {
  if (!label) {
    return {};
  }
  const isCompact = density === "compact";
  if (isCompact) {
    return {
      color: label.color,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: label.backgroundColor,
      backgroundColor: alpha(label.backgroundColor, 0.14),
      height: 22,
      "& .MuiChip-label": {
        px: 0.5,
        py: 0,
        fontSize: 11,
        lineHeight: 1.2,
      },
    };
  }
  return {
    color: label.color,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: label.backgroundColor,
    marginRight: 6,
  };
}

const LabelChips = ({ labels, allLabels, size = "medium", density = "default" }) => {
  function getLabel(id) {
    if (!allLabels) {
      return null;
    }
    const value = _.findWhere(allLabels, { id: id });
    return value;
  }

  if (!labels || !allLabels) {
    return null;
  }

  const isCompact = density === "compact";

  if (isCompact) {
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {labels.map((labelId) => {
          const labelObject = getLabel(labelId);
          if (!labelObject) {
            return null;
          }
          return (
            <Chip
              variant="outlined"
              size="small"
              sx={organizationLabelChipSx(labelObject, density)}
              key={labelObject.id}
              label={labelObject.name}
            />
          );
        })}
      </Box>
    );
  }

  return (
    <Grid container spacing={1}>
      {labels.map((labelId) => {
        const labelObject = getLabel(labelId);
        if (!labelObject) {
          return null;
        }
        return (
          <Grid item key={labelObject.id}>
            <Chip
              variant="outlined"
              size={size}
              sx={organizationLabelChipSx(labelObject, density)}
              label={labelObject.name}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default LabelChips;
